import React, { useState } from "react";
import { useData } from "../util/dataProvider";
import { Link } from "react-router-dom";

export default function Experten({ active }) {
    const { filteredExperten } = useData();
    const CompanyList = ({ category, headline }) => {
        return (
            <div className='cat'>
                <div className='list'>
                    {filteredExperten &&
                        filteredExperten.map((experte, idx) => {
                            return (
                                <Link
                                    to={`/expert/${experte.id}`}
                                    key={idx}
                                    className='list-item'>
                                    <div>
                                        <div className='head'>
                                            {experte.firstname}{" "}
                                            {experte.lastname}
                                        </div>
                                        <div className='sub'>
                                            {experte.fields.join(", ")}
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='button'>Zum Profil</div>
                                    </div>
                                </Link>
                            );
                        })}
                </div>
            </div>
        );
    };
    return (
        <div className='home-content'>
            <div className='bm-header'>
                {active === "experten" && (
                    <div style={{ marginBottom: "7rem" }}>
                        <div className='sub'>
                            Unternehmen im Kompetenzverbund
                        </div>
                        <h1 className='bm-main'>Unsere Innovator*innen</h1>
                    </div>
                )}
                <h3
                    style={{
                        color: "rgb(168, 39, 23)",
                        fontWeight: 300,
                        textTransform: "uppercase",
                        marginBottom: "-2rem",
                    }}>
                    Expert*innen
                </h3>
                <CompanyList
                    category='forschung'
                    headline='Forschung und Entwicklung'
                />
            </div>
        </div>
    );
}
